import { CommonModule } from '@angular/common'
import {
  ChangeDetectorRef,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  HostListener,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { ActivatedRoute, Router, RouterModule } from '@angular/router'
import { Store } from '@ngrx/store'
import { InfiniteScrollDirective } from 'ngx-infinite-scroll'
import { AnimationOptions } from 'ngx-lottie'
import { Observable, Subscription } from 'rxjs'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { AppState } from 'src/app/ngrx/states'
import { getTheme } from 'src/app/ngrx/store/selectors'
import { DictionaryService } from 'src/app/service/data/dictionary.service'
import { PairService } from 'src/app/service/data/pair.service'
import { WordService } from 'src/app/service/data/word.service'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { UserService } from 'src/app/service/user-info/user.service'
import { DdcTabsChipsComponent } from 'src/app/shared/ddc-tabs-chips'
import { DdcButtonNTwoComponent } from 'src/app/shared/ddc/ddc-button-n-two/ddc-button-n-two.component'
import { DdcContentCardComponent } from 'src/app/shared/ddc/ddc-content-card/ddc-content-card.component'
import { DdcDeleteDialogComponent } from 'src/app/shared/ddc/ddc-delete-dialog/ddc-delete-dialog.component'
import { DdcIconFunctionComponent } from 'src/app/shared/ddc/ddc-delete/ddc-icon-function.component'
import { DdcDesktopDialogComponent } from 'src/app/shared/ddc/ddc-desktop-dialog/ddc-desktop-dialog.component'
import { DdcLoadingSkeletonComponent } from 'src/app/shared/ddc/ddc-loading-skeleton/ddc-loading-skeleton.component'
import { DdcMobileSheetComponent } from 'src/app/shared/ddc/ddc-mobile-sheet/ddc-mobile-sheet.component'
import { ContentTypes, DefaultPagination, LibraryChips, Themes } from 'src/app/shared/enums/enums'
import { Dictionary } from 'src/app/shared/models/main/dictionary'
import { DictionaryStateService } from '../../service/state/dictionary-state.service'
import { DdcBookmarkComponent } from '../../shared/ddc/ddc-bookmark/ddc-bookmark.component'
import { DdcElementCountComponent } from '../../shared/ddc/ddc-element-count/ddc-element-count.component'
import { DdcLikeComponent } from '../../shared/ddc/ddc-like/ddc-like.component'
import { DdcNotAvailableComponent } from '../../shared/ddc/ddc-not-available/ddc-not-available.component'
import { DdcProfilePicComponent } from '../../shared/ddc/ddc-profile-pic/ddc-profile-pic.component'
import { DeleteWordPairDicCommand } from '../commands/delete-word-pair-dic/delete-word-pair-dic.command'

@Component({
  selector: 'ddc-library-dic',
  templateUrl: './ddc-library-dic.component.html',
  styleUrl: './ddc-library-dic.component.scss',
  encapsulation: ViewEncapsulation.Emulated,
  imports: [
    AngularMaterialsModules,
    CommonModule,
    RouterModule,
    DdcProfilePicComponent,
    DdcElementCountComponent,
    DdcLikeComponent,
    DdcBookmarkComponent,
    DdcNotAvailableComponent,
    DdcButtonNTwoComponent,
    DdcLoadingSkeletonComponent,
    InfiniteScrollDirective,
    DdcTabsChipsComponent,
    DdcContentCardComponent,
    DdcIconFunctionComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DdcLibraryDicComponent implements OnInit, OnDestroy {
  _isDicInfoLoading: boolean = true
  _isDescriptionExpanded: boolean = false

  _isLightTheme: boolean = true
  _isDarkTheme: boolean = false
  _isPaperTheme: boolean = false
  private themeSubscription: Subscription

  _dicId: number = 0
  _dicTitle: string
  _dicOwnerUsername: string
  _dicOwner: any
  _dicDescription: string
  _dicAllowedWordsN: number = 0
  _dicWordsN: number = 0
  _dicPairsN: number = 0
  _dicWordsNStr: string = '0'
  _dicPairsNStr: string = '0'
  _dicAllowedPairsN: number = 0
  _dicLikesN: number = 0
  _dicBookmarksN: number = 0
  _dicIsBookmarked: boolean = false
  _dicIsLiked: boolean = false
  _theme$: Observable<string>

  _dic_c_type = ContentTypes.DIC
  _dicElement: {}

  _words: any[] = []
  _pairs: any[] = []
  _wordsEnd = false
  _pairsEnd = false

  _wordsCurrentPage = 1
  _pairsCurrentPage = 1

  _isWordsPgnLoading: boolean = false
  _isPairsPgnLoading: boolean = false

  _isWordsEmpty: boolean = false
  _isPairsEmpty: boolean = false

  _isWordsLoading: boolean = true
  _isPairsLoading: boolean = false
  _wordsScrollLoading = false
  _pairsScrollLoading = false
  _isWordsLoaded: boolean = false
  _isPairsLoaded: boolean = false

  _dic: Dictionary = undefined
  _isMine: boolean = false
  _isMobile: boolean = false
  _loggedInUser: any = null

  _clickedColorWords: string = 'basic'
  _clickedColorPairs: string = 'basic'
  _isWordsSelected: boolean = false
  _isPairsSelected: boolean = false

  _wordsPerPage = DefaultPagination.OBJECT_PER_PAGE
  _pairsPerPage = DefaultPagination.OBJECT_PER_PAGE

  _wordsPageInfoLabel = 'Scroll down to load more'
  _pairsPageInfoLabel = 'Scroll down to load more'

  scroll_options: AnimationOptions = {
    path: '/assets/lottie/scroll_down.json',
    loop: true, // Set loop to false for a single playthrough
    autoplay: true,
  }

  loading_options: AnimationOptions = {
    path: '/assets/lottie/loading2.json',
    loop: true, // Set loop to false for a single playthrough
    autoplay: true,
  }

  protected contentTypeID = ContentTypes.DIC

  private userInfoSubscription: Subscription
  constructor(
    private cdr: ChangeDetectorRef,
    private logger: DdcLoggerService,
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private dic_service: DictionaryService,
    private word_service: WordService,
    private pair_service: PairService,
    public themeService: ThemeService,
    private store: Store<AppState>,
    private deleteWordPairDicCommand: DeleteWordPairDicCommand,
    private dictionaryState: DictionaryStateService,
    private userService: UserService,
  ) {
    this._theme$ = this.store.select(getTheme)
    this.themeSubscription = this.themeService.theme$.subscribe(theme => {
      this._isLightTheme = theme === Themes.LIGHT
      this._isDarkTheme = theme === Themes.DARK
      this._isPaperTheme = theme === Themes.PAPER
    })
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this._isMobile = event.target.innerWidth < 1224
  }
  checkIfMobile(): void {
    if (window.innerWidth < 500) {
      // 768px is a common breakpoint for mobile devices
      this._isMobile = true
    } else {
      this._isMobile = false
    }
  }

  ngOnInit(): void {
    this.checkIfMobile()
    this.logger.info('DdcLibraryDicComponent | ngOnInit()')

    // Set words as selected and loading immediately
    this._isWordsSelected = true
    this._isWordsLoading = true
    this._isWordsLoaded = false // Ensure this is false initially
    this._clickedColorWords = 'accent'

    // Wait for both route params and user info before acting, but only once
    let paramsSet = false
    let userInfoSet = false
    let dicId: any
    let dicOwnerUsername: any
    let userInfo: any
    let initialized = false

    // Subscribe to route params
    this.route.params.subscribe(params => {
      dicId = params['dic_id']
      dicOwnerUsername = params['dic_owner']
      paramsSet = true
      // tryInit();
    })

    const tryInit = (): void => {
      if (initialized) return
      if (paramsSet && userInfoSet) {
        initialized = true
        this._dicId = dicId
        this._dicOwnerUsername = dicOwnerUsername
        this._loggedInUser = userInfo
        console.log('userInfoSubscription getDicWordsPage(), _loggedInUser:', this._loggedInUser)
        console.log(
          'userInfoSubscription getDicWordsPage(), _dicOwnerUsername:',
          this._dicOwnerUsername,
        )
        // Do not set _isMine here; rely on backend value from dictionary subscription
        if (
          this._loggedInUser &&
          this._loggedInUser.username &&
          this._dicOwnerUsername &&
          this._loggedInUser.username === this._dicOwnerUsername
        ) {
          this.initializeDictionaryState().then(() => {
            console.log('userInfoSubscription getDicWordsPage()')
            this.getDicWordsPage()
          })
        } else {
          console.log('userInfoSubscription fetchUserDicData()')
          this.fetchUserDicData()
        }
        this.cdr.detectChanges()
      }
    }

    // Subscribe to user info
    this.userInfoSubscription = this.userService.userInfo$.subscribe(u => {
      if (u) {
        userInfo = u
        userInfoSet = true
        console.log('userInfoSubscription userInfo', userInfo)
        tryInit()
      }
    })
    // Use already stored user info
  }
  // For non-owner, fetch dictionary info and words/pairs directly
  fetchUserDicData(): void {
    console.log('fetchUserDicData()')
    this._isDicInfoLoading = true
    this._isWordsLoading = true
    this._isPairsLoading = true
    this._wordsScrollLoading = true
    this._pairsScrollLoading = true
    this._wordsPageInfoLabel = 'Loading...'
    this._pairsPageInfoLabel = 'Loading...'
    this.cdr.detectChanges()

    // Fetch dictionary info
    this.dic_service.get_user_dic(this._dicId, this._dicOwnerUsername).subscribe({
      next: (dic: any) => {
        this._dic = dic
        this._isDicInfoLoading = false
        this._dicOwnerUsername = dic.owner.username
        this._dicOwner = dic.owner
        this._dicTitle = dic.title
        this._dicDescription = dic.description
        this._dicLikesN = dic.likes
        this._dicBookmarksN = dic.bookmarks
        this._dicIsLiked = dic.is_liked
        this._dicIsBookmarked = dic.is_bookmarked
        this._dicWordsN = dic.words_count
        this._dicWordsNStr = dic.words_count.toString()
        this._dicPairsN = dic.pairs_count
        this._dicPairsNStr = dic.pairs_count.toString()
        this.cdr.detectChanges()
      },
      error: (err: any) => {
        this.logger.error('Error fetching dictionary info:', err)
        this._isDicInfoLoading = false
        this.router.navigate(['/library', LibraryChips.DICTIONARIES])
      },
    })

    // Fetch words
    console.log('Fetching words...')
    this.word_service.get_dic_words_page(this._dicId, 1, this._wordsPerPage).subscribe({
      next: (words: any) => {
        this._words = words.results || words
        console.log('Fetched words:', this._words)
        this._isWordsLoading = false
        this._wordsScrollLoading = false
        this._wordsEnd = !words.next
        this._wordsPageInfoLabel = this._wordsEnd ? 'All words loaded' : 'Scroll down to load more'
        this._isWordsLoaded = true
        this._isWordsEmpty = this._words.length === 0
        this.cdr.detectChanges()
      },
      error: (err: any) => {
        this.logger.error('Error fetching words:', err)
        this._isWordsLoading = false
        this._wordsScrollLoading = false
        this._wordsEnd = true
        this._wordsPageInfoLabel = 'Error loading items'
        this._isWordsLoaded = true
        this._isWordsEmpty = true
        this.cdr.detectChanges()
      },
    })

    // Fetch pairs
    this.pair_service.get_dic_pairs_page(this._dicId, 1, this._pairsPerPage).subscribe({
      next: (pairs: any) => {
        this._pairs = pairs.results || pairs
        this._isPairsLoading = false
        this._pairsScrollLoading = false
        this._pairsEnd = !pairs.next
        this._pairsPageInfoLabel = this._pairsEnd ? 'All pairs loaded' : 'Scroll down to load more'
        this._isPairsLoaded = true
        this._isPairsEmpty = this._pairs.length === 0
        this.cdr.detectChanges()
      },
      error: (err: any) => {
        this.logger.error('Error fetching pairs:', err)
        this._isPairsLoading = false
        this._pairsScrollLoading = false
        this._pairsEnd = true
        this._pairsPageInfoLabel = 'Error loading items'
        this._isPairsLoaded = true
        this._isPairsEmpty = true
        this.cdr.detectChanges()
      },
    })
  }

  ngOnDestroy(): void {
    // Clean up state when component is destroyed
    this.dictionaryState.clearState()
    this.themeSubscription?.unsubscribe()
    this.userInfoSubscription?.unsubscribe()
  }

  private async initializeDictionaryState(): Promise<void> {
    try {
      // Load dictionary information
      await this.dictionaryState.loadDictionary(this._dicId, this._dicOwnerUsername)

      // Subscribe to dictionary changes
      this.dictionaryState.dictionary$.subscribe(dic => {
        if (dic) {
          this._dic = dic
          this._isDicInfoLoading = false
          this._dicOwnerUsername = dic.owner.username
          this._dicOwner = dic.owner
          this._dicTitle = dic.title
          this._dicDescription = dic.description
          this._dicLikesN = dic.likes
          this._dicBookmarksN = dic.bookmarks
          this._dicIsLiked = dic.is_liked
          this._dicIsBookmarked = dic.is_bookmarked
          this._dicWordsN = dic.words_count
          this._dicWordsNStr = dic.words_count.toString()
          this._dicPairsN = dic.pairs_count
          this._dicPairsNStr = dic.pairs_count.toString()
          this._isMine = !!dic.is_mine
          console.log('initializeDictionaryState, _isMine:', this._isMine)
          this.cdr.detectChanges()
        }
      })

      // Subscribe to words changes
      this.dictionaryState.words$.subscribe(words => {
        this._words = words

        // Only set loading to false if we actually have words or if we've attempted to load
        if (this._isWordsLoaded || (words && words.length > 0)) {
        } else {
        }

        this.cdr.detectChanges()
      })

      // Subscribe to pairs changes
      this.dictionaryState.pairs$.subscribe(pairs => {
        this._pairs = pairs
        this.cdr.detectChanges()
      })

      // Subscribe to loading states
      this.dictionaryState.wordsLoading$.subscribe(loading => {
        this._wordsScrollLoading = loading
        this.cdr.detectChanges()
      })

      this.dictionaryState.pairsLoading$.subscribe(loading => {
        this._pairsScrollLoading = loading
        this.cdr.detectChanges()
      })
    } catch (error) {
      this.logger.error('Failed to initialize dictionary state:', error)
      this.router.navigate(['/library', LibraryChips.DICTIONARIES])
    }
  }

  getUserDic(): void {
    // This method is now handled by the dictionary state service
    // Refresh dictionary data
    this.dictionaryState.loadDictionary(this._dicId, this._dicOwnerUsername)
  }

  openEditDictionaryDialog(): void {
    if (this._isMobile) {
      const dialogConfig = new MatDialogConfig()

      // Get the theme synchronously (if needed, subscribe in advance and store the value in a variable)
      let themeClass = ''
      this._theme$
        .subscribe(theme => {
          themeClass = theme
        })
        .unsubscribe()
      dialogConfig.panelClass = ['mobile-sheet-container', themeClass]

      dialogConfig.position = { bottom: '0' }
      dialogConfig.width = '100%'
      dialogConfig.height = '80vh'
      dialogConfig.maxWidth = '100vw'
      dialogConfig.hasBackdrop = true
      dialogConfig.backdropClass = 'mobile-sheet-backdrop'
      dialogConfig.enterAnimationDuration = '300ms'
      dialogConfig.exitAnimationDuration = '200ms'
      dialogConfig.data = { type: 'edit-dic', element: this._dic }
      const dialogRef = this.dialog.open(DdcMobileSheetComponent, dialogConfig)
      dialogRef.afterClosed().subscribe(result => {
        this.getUserDic()
      })
    } else {
      const dialogConfig = new MatDialogConfig()
      dialogConfig.width = '600px'
      dialogConfig.maxWidth = '90vw'
      dialogConfig.hasBackdrop = true
      dialogConfig.data = { type: 'edit-dic', element: this._dic }
      const dialogRef = this.dialog.open(DdcDesktopDialogComponent, dialogConfig)
      dialogRef.afterClosed().subscribe(result => {
        this.getUserDic()
      })
    }
  }

  openReadWordDialog(index: any): void {
    if (this._isMobile) {
      const dialogConfig = new MatDialogConfig()

      // Get the theme synchronously (if needed, subscribe in advance and store the value in a variable)
      let themeClass = ''
      this._theme$
        .subscribe(theme => {
          themeClass = theme
        })
        .unsubscribe()
      dialogConfig.panelClass = ['mobile-sheet-container', themeClass]

      dialogConfig.position = { bottom: '0' }
      dialogConfig.width = '100%'
      dialogConfig.height = '80vh'
      dialogConfig.maxWidth = '100vw'
      dialogConfig.hasBackdrop = true
      dialogConfig.backdropClass = 'mobile-sheet-backdrop'
      dialogConfig.enterAnimationDuration = '300ms'
      dialogConfig.exitAnimationDuration = '200ms'
      dialogConfig.data = { type: 'read-word', element: this._words[index] }
      const dialogRef = this.dialog.open(DdcMobileSheetComponent, dialogConfig)
    } else {
      const dialogConfig = new MatDialogConfig()
      dialogConfig.width = '600px'
      dialogConfig.maxWidth = '90vw'
      dialogConfig.hasBackdrop = true
      dialogConfig.data = { type: 'read-word', element: this._words[index] }
      const dialogRef = this.dialog.open(DdcDesktopDialogComponent, dialogConfig)
      dialogRef.afterClosed().subscribe(result => {
        if (result === 'word') {
        }
      })
    }
  }

  openReadPairDialog(index: any): void {
    if (this._isMobile) {
      const dialogConfig = new MatDialogConfig()

      // Get the theme synchronously (if needed, subscribe in advance and store the value in a variable)
      let themeClass = ''
      this._theme$
        .subscribe(theme => {
          themeClass = theme
        })
        .unsubscribe()
      dialogConfig.panelClass = ['mobile-sheet-container', themeClass]

      dialogConfig.position = { bottom: '0' }
      dialogConfig.width = '100%'
      dialogConfig.height = '80vh'
      dialogConfig.maxWidth = '100vw'
      dialogConfig.hasBackdrop = true
      dialogConfig.backdropClass = 'mobile-sheet-backdrop'
      dialogConfig.enterAnimationDuration = '300ms'
      dialogConfig.exitAnimationDuration = '200ms'
      dialogConfig.data = { type: 'read-pair', element: this._pairs[index] }
      const dialogRef = this.dialog.open(DdcMobileSheetComponent, dialogConfig)
    } else {
      const dialogConfig = new MatDialogConfig()
      dialogConfig.width = '600px'
      dialogConfig.maxWidth = '90vw'
      dialogConfig.hasBackdrop = true
      dialogConfig.data = { type: 'read-pair', element: this._pairs[index] }
      const dialogRef = this.dialog.open(DdcDesktopDialogComponent, dialogConfig)
      dialogRef.afterClosed().subscribe(result => {
        if (result === 'pair') {
        }
      })
    }
  }
  onWordsScroll(): void {
    this.logger.info('DdcUserComponent: onWordsScroll()')
    this._wordsCurrentPage++
    this.appendWordsData()
  }

  appendWordsData = (): void => {
    this.logger.info('DdcUserComponent: appendWordsData()')
    this.logger.info('_wordsCurrentPage', this._wordsCurrentPage)
    this.logger.info('_wordsPerPage', this._wordsPerPage)

    this._wordsScrollLoading = true
    // Always set loading label when fetching a new page
    this._wordsPageInfoLabel = 'Loading...'

    this.toggleWordsPaginationLoading()
    this.word_service
      .get_dic_words_page(this._dicId, this._wordsCurrentPage, this._wordsPerPage)
      .subscribe((res: any) => {
        if (res) {
          setTimeout(() => {
            if (res.detail != 'Invalid page.') {
              this._words = this._words.concat(res.results)
              this._wordsEnd = false
              this._wordsPageInfoLabel = 'Scroll down to load more'
            } else {
              this._wordsEnd = true
              this._wordsPageInfoLabel = 'All words loaded.'
            }
            this.toggleWordsPaginationLoading()
            this._wordsScrollLoading = false
          }, 1000) // two seconds
        }
      })
  }

  onPairsScroll(): void {
    this.logger.info('DdcLibraryDicComponent | onPairsScroll()')
    if (!this._pairsScrollLoading && !this._pairsEnd) {
      this._pairsScrollLoading = true
      this._pairsPageInfoLabel = 'Loading more...'

      const currentPairsCount = this._pairs.length

      const promise = this.dictionaryState.loadMorePairs()
      if (promise) {
        promise
          .then(() => {
            // Check if new pairs were actually loaded
            const newPairsCount = this._pairs.length
            if (newPairsCount === currentPairsCount) {
              // No new pairs loaded, we've reached the end
              this._pairsEnd = true
              this._pairsPageInfoLabel = 'All pairs loaded'
            } else {
              // New pairs were loaded
              this._pairsEnd = false
              this._pairsPageInfoLabel = 'Scroll down to load more'
            }
            this._pairsScrollLoading = false
          })
          .catch(error => {
            this._pairsEnd = true
            this._pairsPageInfoLabel = 'No more pairs'
            this._pairsScrollLoading = false
            this.logger.error('Error loading more pairs:', error)
          })
      }
    }
  }

  openDeleteWordDialog(index: number): void {
    const dialogRef = this.dialog.open(DdcDeleteDialogComponent, {
      data: {
        type: 'Word',
        element: this._words[index],
      },
    })

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'delete-element') {
        // Set the command arguments
        this.deleteWordPairDicCommand.setArgs({
          content_type_id: ContentTypes.WORD,
          object_id: this._words[index].id,
        })

        // Execute the delete command
        this.deleteWordPairDicCommand.execute().subscribe(() => {
          // Remove from local array
          const indexToRemove = this._words.findIndex(word => word.id === this._words[index].id)
          if (indexToRemove !== -1) {
            this.cdr.detectChanges()
          }
        })
      }
    })
  }

  openDeletePairDialog(index: number): void {
    const dialogRef = this.dialog.open(DdcDeleteDialogComponent, {
      data: {
        type: 'Pair',
        element: this._pairs[index],
      },
    })

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'delete-element') {
        // Set the command arguments
        this.deleteWordPairDicCommand.setArgs({
          content_type_id: ContentTypes.PAIR,
          object_id: this._pairs[index].id,
        })

        // Execute the delete command
        this.deleteWordPairDicCommand.execute().subscribe(() => {
          // Remove from local array
          const indexToRemove = this._pairs.findIndex(pair => pair.id === this._pairs[index].id)
          if (indexToRemove !== -1) {
            this.cdr.detectChanges()
          }
        })
      }
    })
  }

  clearWordsParameters(): void {
    this._wordsCurrentPage = 1
  }

  clearPairsParameters(): void {
    this._pairsCurrentPage = 1
  }

  openEditProfileDialog(): void {}

  clickedChip(name: string, initial: boolean = false): void {
    if (!initial) {
      // Only reset selections when not the initial load
      this._clickedColorWords = 'basic'
      this._clickedColorPairs = 'basic'
      this._isWordsSelected = false
      this._isPairsSelected = false
    }

    if (name == 'words') {
      this._clickedColorWords = 'accent'
      this._isWordsSelected = true
      if (initial) {
        // Do not call getDicWordsPage() here to avoid double fetch on page load
        this._isWordsLoading = true
        this.cdr.detectChanges()
      } else {
        this.getDicWordsPage()
      }
    } else if (name == 'pairs') {
      this._clickedColorPairs = 'accent'
      this._isPairsSelected = true
      this.getDicPairsPage()
    }
  }

  toggleWordsPaginationLoading = (): void => {
    this._isWordsPgnLoading = !this._isWordsPgnLoading
  }

  togglePairsPaginationLoading = (): void => {
    this._isPairsPgnLoading = !this._isPairsPgnLoading
  }

  getDicWordsPage(): void {
    if (this._isMine) {
      console.log('Fetching words for owner...')
      // ...existing code for owner (dictionaryState)...
      this.logger.info('DdcLibraryDicComponent | getDicWordsPage()')
      this._isWordsLoading = true
      this._wordsScrollLoading = true
      this._wordsPageInfoLabel = 'Loading...'
      this._isWordsEmpty = false
      this._isWordsLoaded = false
      this.cdr.detectChanges() // Force change detection
      this.toggleWordsPaginationLoading()
      // Reset and load words using dictionary state service
      this.dictionaryState
        .loadWords(true)
        .then(() => {
          this._wordsEnd = false
          this._wordsPageInfoLabel = 'Scroll down to load more'
          this._isWordsLoading = false
          this._wordsScrollLoading = false
          this._isWordsLoaded = true
          this.toggleWordsPaginationLoading()
          this.cdr.detectChanges() // Force change detection
        })
        .catch(error => {
          this.logger.error('Error loading words:', error)
          this._wordsEnd = true
          this._isWordsEmpty = true
          this._wordsPageInfoLabel = 'Error loading items'
          this._isWordsLoading = false
          this._wordsScrollLoading = false
          this._isWordsLoaded = true
          this.toggleWordsPaginationLoading()
          this.cdr.detectChanges() // Force change detection
        })
    } else {
      // ...non-owner: fetch words directly
      this._isWordsLoading = true
      this._wordsScrollLoading = true
      this._wordsPageInfoLabel = 'Loading...'
      this._isWordsEmpty = false
      this._isWordsLoaded = false
      this.cdr.detectChanges()
      this.word_service.get_dic_words_page(this._dicId, 1, this._wordsPerPage).subscribe({
        next: (words: any) => {
          this._words = words.results || words
          this._isWordsLoading = false
          this._wordsScrollLoading = false
          this._wordsEnd = !words.next
          this._wordsPageInfoLabel = this._wordsEnd
            ? 'All words loaded'
            : 'Scroll down to load more'
          this._isWordsLoaded = true
          this._isWordsEmpty = this._words.length === 0
          this.cdr.detectChanges()
        },
        error: (err: any) => {
          this.logger.error('Error fetching words:', err)
          this._isWordsLoading = false
          this._wordsScrollLoading = false
          this._wordsEnd = true
          this._wordsPageInfoLabel = 'Error loading items'
          this._isWordsLoaded = true
          this._isWordsEmpty = true
          this.cdr.detectChanges()
        },
      })
    }
  }

  onImportToDicClicked(): void {
    if (this._isMobile) {
      const dialogConfig = new MatDialogConfig()

      // Get the theme synchronously (if needed, subscribe in advance and store the value in a variable)
      let themeClass = ''
      this._theme$
        .subscribe(theme => {
          themeClass = theme
        })
        .unsubscribe()
      dialogConfig.panelClass = ['mobile-sheet-container', themeClass]

      dialogConfig.position = { bottom: '0' }
      dialogConfig.width = '100%'
      dialogConfig.height = '80vh'
      dialogConfig.maxWidth = '100vw'
      dialogConfig.hasBackdrop = true
      dialogConfig.backdropClass = 'mobile-sheet-backdrop'
      dialogConfig.enterAnimationDuration = '300ms'
      dialogConfig.exitAnimationDuration = '200ms'
      dialogConfig.data = {
        type: 'add-to-dic',
        element: { id: this._dic.id, title: this._dic.title },
      }
      const dialogRef = this.dialog.open(DdcMobileSheetComponent, dialogConfig)
      dialogRef.afterClosed().subscribe(result => {
        // this.getUserDic()
      })
    } else {
      const dialogConfig = new MatDialogConfig()
      dialogConfig.width = '600px'
      dialogConfig.maxWidth = '90vw'
      dialogConfig.hasBackdrop = true
      dialogConfig.data = {
        type: 'add-to-dic',
        element: { id: this._dic.id, title: this._dic.title },
      }
      const dialogRef = this.dialog.open(DdcDesktopDialogComponent, dialogConfig)
      dialogRef.afterClosed().subscribe(result => {
        // this.getUserDic()
      })
    }
    // this.logger.info('DdcNavbarComponent openAddDialog()')

    // const dialogRef = this.dialog.open(DdcAddDialogComponent, {
    //   data: {
    //     hasDic: true,
    //     dicId: this._dic.id,
    //     dicTitle: this._dic.title,
    //     targetChip: 'word',
    //   },
    //   // panelClass: 'custom-ddc-dialog'
    // })

    // dialogRef.afterClosed().subscribe(result => {
    //   // Handle any actions after the dialog is closed, e.g., updating the user's profile picture.
    //   if (result === 'dialogClosed') {
    //     // Reload or refresh the parent page
    //     window.location.reload()
    //   }
    // })
  }

  getDicPairsPage(): void {
    if (this._isMine) {
      // ...existing code for owner (dictionaryState)...
      this.logger.info('DdcLibraryDicComponent | getDicPairsPage()')
      this._isPairsLoading = true
      this._pairsScrollLoading = true
      this._pairsPageInfoLabel = 'Loading...'
      this._isPairsEmpty = false
      // Reset and load pairs using dictionary state service
      this.dictionaryState
        .loadPairs(true)
        .then(() => {
          this._pairsEnd = false
          this._pairsPageInfoLabel = 'Scroll down to load more'
          this._isPairsLoading = false
          this._pairsScrollLoading = false
          this._isPairsLoaded = true
          this.togglePairsPaginationLoading()
        })
        .catch(error => {
          this.logger.error('Error loading pairs:', error)
          this._pairsEnd = true
          this._isPairsEmpty = true
          this._pairsPageInfoLabel = 'Error loading items'
          this._isPairsLoading = false
          this._pairsScrollLoading = false
          this.togglePairsPaginationLoading()
        })
    } else {
      // ...non-owner: fetch pairs directly
      this._isPairsLoading = true
      this._pairsScrollLoading = true
      this._pairsPageInfoLabel = 'Loading...'
      this._isPairsEmpty = false
      this.cdr.detectChanges()
      this.pair_service.get_dic_pairs_page(this._dicId, 1, this._pairsPerPage).subscribe({
        next: (pairs: any) => {
          this._pairs = pairs.results || pairs
          this._isPairsLoading = false
          this._pairsScrollLoading = false
          this._pairsEnd = !pairs.next
          this._pairsPageInfoLabel = this._pairsEnd
            ? 'All pairs loaded'
            : 'Scroll down to load more'
          this._isPairsLoaded = true
          this._isPairsEmpty = this._pairs.length === 0
          this.togglePairsPaginationLoading()
          this.cdr.detectChanges()
        },
        error: (err: any) => {
          this.logger.error('Error fetching pairs:', err)
          this._isPairsLoading = false
          this._pairsScrollLoading = false
          this._pairsEnd = true
          this._pairsPageInfoLabel = 'Error loading items'
          this._isPairsLoaded = true
          this._isPairsEmpty = true
          this.togglePairsPaginationLoading()
          this.cdr.detectChanges()
        },
      })
    }
  }

  openEditWordDialog(index: number): void {
    if (this._isMobile) {
      const dialogConfig = new MatDialogConfig()

      // Get the theme synchronously (if needed, subscribe in advance and store the value in a variable)
      let themeClass = ''
      this._theme$
        .subscribe(theme => {
          themeClass = theme
        })
        .unsubscribe()
      dialogConfig.panelClass = ['mobile-sheet-container', themeClass]

      dialogConfig.position = { bottom: '0' }
      dialogConfig.width = '100%'
      dialogConfig.height = '80vh'
      dialogConfig.maxWidth = '100vw'
      dialogConfig.hasBackdrop = true
      dialogConfig.backdropClass = 'mobile-sheet-backdrop'
      dialogConfig.enterAnimationDuration = '300ms'
      dialogConfig.exitAnimationDuration = '200ms'
      dialogConfig.data = { type: 'edit-word', element: this._words[index] }
      const dialogRef = this.dialog.open(DdcMobileSheetComponent, dialogConfig)
    } else {
      const dialogConfig = new MatDialogConfig()
      dialogConfig.width = '600px'
      dialogConfig.maxWidth = '90vw'
      dialogConfig.hasBackdrop = true
      dialogConfig.data = { type: 'edit-word', element: this._words[index] }
      const dialogRef = this.dialog.open(DdcDesktopDialogComponent, dialogConfig)
      dialogRef.afterClosed().subscribe(result => {
        if (result === 'word') {
        }
      })
    }
  }

  openEditPairDialog(index: number): void {
    if (this._isMobile) {
      const dialogConfig = new MatDialogConfig()

      // Get the theme synchronously (if needed, subscribe in advance and store the value in a variable)
      let themeClass = ''
      this._theme$
        .subscribe(theme => {
          themeClass = theme
        })
        .unsubscribe()
      dialogConfig.panelClass = ['mobile-sheet-container', themeClass]

      dialogConfig.position = { bottom: '0' }
      dialogConfig.width = '100%'
      dialogConfig.height = '80vh'
      dialogConfig.maxWidth = '100vw'
      dialogConfig.hasBackdrop = true
      dialogConfig.backdropClass = 'mobile-sheet-backdrop'
      dialogConfig.enterAnimationDuration = '300ms'
      dialogConfig.exitAnimationDuration = '200ms'
      dialogConfig.data = { type: 'edit-pair', element: this._pairs[index] }
      const dialogRef = this.dialog.open(DdcMobileSheetComponent, dialogConfig)
    } else {
      const dialogConfig = new MatDialogConfig()
      dialogConfig.width = '600px'
      dialogConfig.maxWidth = '90vw'
      dialogConfig.hasBackdrop = true
      dialogConfig.data = { type: 'edit-pair', element: this._pairs[index] }
      const dialogRef = this.dialog.open(DdcDesktopDialogComponent, dialogConfig)
      dialogRef.afterClosed().subscribe(result => {
        if (result === 'pair') {
        }
      })
    }
  }

  openDeleteDictionaryDialog(): void {
    const dialogRef = this.dialog.open(DdcDeleteDialogComponent, {
      data: {
        type: 'Dictionary',
        element: this._dic,
      },
    })

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'delete-element') {
        // Set the command arguments
        this.deleteWordPairDicCommand.setArgs({
          content_type_id: ContentTypes.DIC,
          object_id: this._dic.id,
        })

        // Execute the delete command
        this.deleteWordPairDicCommand.execute().subscribe(() => {
          this.router.navigate(['/library'])
        })
      }
    })
  }
}
